import { useState, useEffect, useRef } from 'react'

// TypeScript-ready hook to get the width of a container
const useContainerSize = (): [React.RefObject<HTMLDivElement>, number, number] => {
  // Use React.RefObject for specific HTML element type
  const containerRef = useRef<HTMLDivElement>(null)
  const [width, setWidth] = useState<number>(0)
  const [height, setHeight] = useState<number>(0)

  useEffect(() => {
    const handleResize = () => {
      if (containerRef.current) {
        setWidth(containerRef.current.offsetWidth)
        setHeight(containerRef.current.offsetHeight)
      }
    }

    handleResize() // Set initial size
    window.addEventListener('resize', handleResize) // Adjust on window resize

    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  return [containerRef, width, height]
}

export default useContainerSize
